export default "__VITE_ASSET__B4Jh_PZO__"